// extracted by mini-css-extract-plugin
module.exports = {"TopMenu":"TopMenu--TopMenu--10QotH8","Link":"TopMenu--Link--2S4g6Mg"};